// extracted by mini-css-extract-plugin
export var typingIndicator = "_ol-0";